export default {
    variants: {
        closeAccountLink: {
            fontWeight: 'normal',
            textTransform: 'none',
            fontSize: 'md'
        }
    }
}
